import React, { useMemo } from "react";
import { useTimeTrackingContext } from "../context/TimeTrackingContext";

export const TimeTrackingControls = () => {
  const { state, startSession, stopSession } = useTimeTrackingContext();

  const text = useMemo(() => {
    return state === "active" ? "Завершить работу" : "Начать работу";
  }, [state]);

  const handleClick = () => {
    if (state === "active") {
      stopSession();
    } else {
      startSession();
    }
  };

  if (!state) {
    return null;
  }

  return (
    <button
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: state === "active" ? "#ed6f78" : "#2cbea0",
        color: "white",
        border: "none",
        borderRadius: "4px",
        padding: "10px 16px",
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        minWidth: "120px",
        height: "40px",
        outline: "none"
      }}
      onClick={handleClick}
    >
      {text}
    </button>
  );
};
